import React, {type FC} from 'react'
import {useGetAdaptiveStyle, Text} from 'uikit'
import {useAppSelector, useAppDispatch} from 'store'
import {getTranslates} from 'store/translates/selectors'
import {getStatusModal} from 'store/modal/selectors'
import {hideModalThunk} from 'store/modal/thunk'
import {StartGameMobileButton} from 'src/common/components/StartGameMobileButton'
import {Word} from 'src/common/components/GamePage/WordBox/Word'
import {
  adaptiveConfigImgWidth,
  adaptiveConfigModal,
} from 'src/common/components/GamePage/consts'
import type {CallbackType} from 'store/modal/entities'
import {WinImg} from 'src/common/components/WinImg'
import {ModalWrap} from '../ModalWrap'
import styles from './WinModal.scss'

export const WinModal: FC<{}> = () => {
  const {style: styleWrapperImg} = useGetAdaptiveStyle([adaptiveConfigImgWidth])
  const {style} = useGetAdaptiveStyle(adaptiveConfigModal)
  const dispatch = useAppDispatch()
  const translates = useAppSelector(getTranslates)
  const status = useAppSelector(getStatusModal)
  
  const handleClose = (callback: CallbackType) => dispatch(hideModalThunk(callback))

  return (
    <ModalWrap classes={{modal: styles.wrapper}} style={style}>
      <Word />
      <Text className={styles.title} type="title" color="primary">{translates.YOU_WIN}</Text>
      <div className={styles.imgStyle} style={styleWrapperImg}><WinImg /></div>
      <StartGameMobileButton onClick={handleClose} disabled={status === 'close'} />
    </ModalWrap>
  )
}
